import { faMegaphone, faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/UI/V3/Button/Button';
import { FunctionComponent } from 'react';
import styles from './EmailCampaignsEmptyState.module.scss';

interface EmailCampaignsEmptyStateProps {
    /** Opens the AddEmailCampaign wizard — shared with the header's own
     *  "New Email Campaign" button in the non-empty path. */
    onOpenNew: () => void;
}

const EmailCampaignsEmptyState: FunctionComponent<EmailCampaignsEmptyStateProps> = ({ onOpenNew }) => {
    return (
        <div className={styles.root}>
            <div className={styles.centeredContent}>
                <div className={styles.card}>
                    <div className={styles.iconBadge}>
                        <FontAwesomeIcon
                            icon={faMegaphone}
                            className={styles.icon}
                        />
                    </div>

                    <h3 className={styles.title}>
                        Create a New
                        <br />
                        Email Campaign
                    </h3>

                    <p className={styles.description}>Click the &quot;New Email Campaign&quot; button to add one.</p>

                    <div className={styles.actions}>
                        <Button
                            type="button"
                            size="large"
                            variant="primary"
                            className={styles.primaryButton}
                            leftIcon={faPlus}
                            label="New Email Campaign"
                            onClick={onOpenNew}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmailCampaignsEmptyState;
